import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { ApiService } from '@core/services/api.service';

@Component({
  standalone: true,
  selector: 'app-pulse-widget',
  imports: [CommonModule, MatIconModule],
  templateUrl: './pulse-widget.component.html',
  styleUrls: ['./pulse-widget.component.scss'],
})
export class PulseWidgetComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  loading = true;
  birthdays: any[] = [];
  workAnniversaries: any[] = [];
  weddings: any[] = [];
  newHires: any[] = [];
  holidays: any[] = [];

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.api.get('/dashboard/pulse').pipe(
      catchError(() => of(null)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res: any) => {
      this.birthdays = res?.birthdays || [];
      this.workAnniversaries = res?.workAnniversaries || [];
      this.weddings = res?.weddings || [];
      this.newHires = res?.newHires || [];
      this.holidays = res?.holidays || [];
      this.loading = false;
    });
  }

  get celebrations(): any[] {
    return [
      ...this.birthdays.map(b => ({ ...b, icon: 'cake', tag: 'Birthday' })),
      ...this.workAnniversaries.map(a => ({ ...a, icon: 'military_tech', tag: `${a.years} yr${a.years > 1 ? 's' : ''}` })),
      ...this.weddings.map(w => ({ ...w, icon: 'favorite', tag: 'Anniversary' })),
    ];
  }

  get hasAnything(): boolean {
    return !!(this.celebrations.length || this.newHires.length || this.holidays.length);
  }

  initials(name: string): string {
    return (name || '').split(/\s+/).filter(Boolean).map(p => p[0]).join('').slice(0, 2).toUpperCase();
  }
}
